// extracted by mini-css-extract-plugin
module.exports = {"text":"Problems-module__text___1ccYV","ProblemsList":"Problems-module__ProblemsList___2hmiy","number":"Problems-module__number___1wY8H"};